var React = require('react');
var ReactNative = require('react-native');

var AppActions = require('./AppActions.js');
var LinkingManager = require('./wrappers/LinkingManager');
var Globals = require('./Globals');
var NetworkManager = require('./NetworkManager');
var FadingView = require('./FadingView');
var FeedPlusView = require('./FeedPlusView');
var FeedPlusSideView = require('./FeedPlusSideView');
var Animated = require('./wrappers/Animated');
var ReUpTabBar = require('./ReUpTabBar');
var AddToWalletButton = require('./AddToWalletButton');
var ArcMeter = require('./ArcMeter');
var PointsTicker = require('./PointsTicker');
var createReactClass = require('create-react-class');
const Icon = require('./wrappers/ReUpIcon');
var FEED_HEADER_HEIGHT = 80;

var Svg = require('./wrappers/react-native-svg-wrapper');
var {
    Path,
    G,
    Circle
} = Svg;

var Menu = require('./menu.js')
var FeedCard = require('./feedCard.js')
var ModelConstants = require('./constants/ModelConstants.js');
var ReUpScrollView = require('./ReUpScrollView.js');
var ReUpIconButton = require('./ReUpIconButton.js');
var ReUpField = require('./ReUpField.js');
var ShadowView = require('./ShadowView.js');
var ReUpText = require('./ReUpText');
var ReUpCountdown = require('./ReUpCountdown');
var { BlurView, VibrancyView } = require('./wrappers/react-native-blur-wrapper');
var MapView = require('./wrappers/react-native-maps-wrapper');
var ReUpButton = require('./ReUpButton');
var Meter = require('./Meter.js');

var MK = require('./wrappers/react-native-material-kit-wrapper');
var {
  MKButton,
  MKTextField,
} = MK;

var ParallaxScrollView = require('./wrappers/react-native-parallax-scroll-view-wrapper');

var dismissKeyboard = require('react-native-dismiss-keyboard');

var {
  View,
  WebView,
  ScrollView,
  StyleSheet,
  Platform,
  Image,
  TouchableHighlight,
  Dimensions,
  TouchableWithoutFeedback
} = ReactNative;

function findGetParameter(parameterName)
{
  var result = null,
    tmp = [];
  location.search
    .substr(1)
    .split("&")
    .forEach(function (item)
    {
      tmp = item.split("=");
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });

  return result;
}

var BasicHome = createReactClass(
{
  getDefaultProps : function()
  {
    return {
    }
  },

  getInitialState : function()
  {
    var maxWidth = 400;
    var maxHeight = 700;
    var width = Math.min(this.props.initialLayout.width-24, maxWidth);
    var height = Math.min(this.props.initialLayout.height-24, maxHeight);
    // var ratio = parseFloat(750 / 1334);
    // width = Math.min(width, height*ratio);
    // height = Math.min(height, width/ratio);
    var horizontalMargin = (this.props.initialLayout.width - width)/2;
    var verticalMargin = (this.props.initialLayout.height - height)/2;
    return {
      horizontalMargin,
      verticalMargin,
      rotationFront: new Animated.Value(90),
      rotationBack: new Animated.Value(90),

      isShowingFront: true,

      isShowingHome: false,
      isShowingError: false,

      userName:null,
      rewards:[],
      points:0,

      isInError:false,
      errorMessage:"",
    }
  },

  _context: 0,
  componentDidMount : function()
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = appManager.getLocalizationManager();
    var userID = findGetParameter("userid");
    var hash = findGetParameter("hash");

    if( userID != null && hash != null )
    {
      if( appManager.isLoggedIn() ) // appmanager initialize managed to get the user
      {
        var user = appManager.currentUser();
        thisThing.setState({points:user.Points});
        NetworkManager.update(appManager, ["Rewards", "Campaigns"], (data)=>
        {
          thisThing.setState({isShowingHome:true, rewards:data.Rewards, points:user.Points})

          var checkInCampaign = null;
          for( var i = 0; i < data.Campaigns.length; i++ )
          {
            var campaign = data.Campaigns[i];
            if( campaign.Type == "Checkin" || campaign.Type == "CheckIn" ) checkInCampaign = JSON.parse(campaign.CampaignBlob);
          }
          thisThing.setState({
            dollarsPerPoint:checkInCampaign == null ? null : checkInCampaign.DollarsPerPoint,
          });

          thisThing.showFront();
        }, ()=>
        {
          thisThing.setState({isShowingHome:true, rewards:[]})
          thisThing.showFront();
        }, ()=>
        {
          thisThing.setState({isShowingHome:true, rewards:[]})
          thisThing.showFront();
        })
      }
      else // should never happen, but hey, you never know
      {
        NetworkManager.getUser(appManager, userID, hash, (urlUser)=>
        {
          thisThing.setState({points:urlUser.Points});
          urlUser[ModelConstants.Password] = hash;
          appManager.setCurrentUser(urlUser, ()=>
          {

          })

          NetworkManager.update(appManager, ["Rewards", "Campaigns"], (data)=>
          {
            thisThing.setState({isShowingHome:true, rewards:data.Rewards})

            var checkInCampaign = null;
            for( var i = 0; i < data.Campaigns.length; i++ )
            {
              var campaign = data.Campaigns[i];
              if( campaign.Type == "Checkin" || campaign.Type == "CheckIn" ) checkInCampaign = JSON.parse(campaign.CampaignBlob);
            }
            thisThing.setState({
              dollarsPerPoint:checkInCampaign == null ? null : checkInCampaign.DollarsPerPoint,
            });

            thisThing.showFront();
          }, ()=>
          {
            thisThing.setState({isShowingHome:true, rewards:[]})
            thisThing.showFront();
          }, ()=>
          {
            thisThing.setState({isShowingHome:true, rewards:[]})
            thisThing.showFront();
          })
        }, ()=>
        {
          thisThing.setState({isShowingError:true, errorTitle:locManager.localizedStringForKey("EXPIRED_LINK_ERROR_TITLE"), errorBody:locManager.localizedStringForKey("EXPIRED_LINK_ERROR_BODY")});
          thisThing.showFront();
        }, ()=>
        {
          thisThing.setState({isShowingError:true, errorTitle:locManager.localizedStringForKey("CONNECTION_ISSUE_TITLE"), errorBody:locManager.localizedStringForKey("NO_CONNECTION_STATEMENT")});
          thisThing.showFront();
        })
      }
    }
    else if( appManager._isDemo )
    {
      NetworkManager.login(appManager, 'kjregan10@gmail.com', 'asdfwxyzabcd', (urlUser)=>
      {
        setTimeout(()=>
        {
          thisThing.setState({points:urlUser.Points});
        }, 500);
        appManager.setCurrentUser(urlUser, ()=>
        {

        })

        NetworkManager.update(appManager, ["Rewards", "Campaigns"], (data)=>
        {
          thisThing.setState({isShowingHome:true, rewards:data.Rewards})

          var checkInCampaign = null;
          for( var i = 0; i < data.Campaigns.length; i++ )
          {
            var campaign = data.Campaigns[i];
            if( campaign.Type == "Checkin" || campaign.Type == "CheckIn" ) checkInCampaign = JSON.parse(campaign.CampaignBlob);
          }
          thisThing.setState({
            dollarsPerPoint:checkInCampaign == null ? null : checkInCampaign.DollarsPerPoint,
          });

          thisThing.showFront();
        }, ()=>
        {
          thisThing.setState({isShowingHome:true, rewards:[]})
          thisThing.showFront();
        }, ()=>
        {
          thisThing.setState({isShowingHome:true, rewards:[]})
          thisThing.showFront();
        })
      }, ()=>
      {
        thisThing.setState({isShowingError:true,  errorTitle:locManager.localizedStringForKey("EXPIRED_LINK_ERROR_TITLE"), errorBody:locManager.localizedStringForKey("EXPIRED_LINK_ERROR_BODY")});
        thisThing.showFront();
      }, ()=>
      {
        thisThing.setState({isShowingError:true, errorTitle:locManager.localizedStringForKey("CONNECTION_ISSUE_TITLE"), errorBody:locManager.localizedStringForKey("NO_CONNECTION_STATEMENT")});
        thisThing.showFront();
      })
    }
    else
    {
      this.setState({isShowingCFD:true});
      this.showFront();
    }
  },

  componentWillUnmount : function()
  {
  },

  componentWillReceiveProps : function(newProps)
  {
    if( typeof newProps.initialLayout !== 'undefined' )
    {
      var maxWidth = 400;
      var maxHeight = 700;
      var width = Math.min(newProps.initialLayout.width-24, maxWidth);
      var height = Math.min(newProps.initialLayout.height-24, maxHeight);
      // var ratio = parseFloat(750 / 1234);
      // width = Math.min(width, height*ratio);
      // height = Math.min(height, width/ratio);
      var horizontalMargin = (newProps.initialLayout.width - width)/2;
      var verticalMargin = (newProps.initialLayout.height - height)/2;

      this.setState({horizontalMargin, verticalMargin});
    }
  },

  _showingFront : false,
  showFront : function()
  {
    if( this._showingFront ) return;
    this._showingFront = true;

    var thisThing = this;
    Animated.timing(
      thisThing.state.rotationBack,
      {
        toValue: 90,
        duration: 200
      }
    ).start(function()
    {
      thisThing.setState({isShowingFront:true});
      Animated.timing(
        thisThing.state.rotationFront,
        {
          toValue: 0,
          duration: 200
        }
      ).start(function()
      {

      });
    });
  },

  showBack : function()
  {
    if( !this._showingFront ) return;
    this._showingFront = false;

    var thisThing = this;
    Animated.timing(
      thisThing.state.rotationFront,
      {
        toValue: 90,
        duration: 200
      }
    ).start(function()
    {
      thisThing.setState({isShowingFront:false});
      Animated.timing(
        thisThing.state.rotationBack,
        {
          toValue: 0,
          duration: 200
        }
      ).start(function()
      {

      });
    });
  },

  checkUserChanged : function()
  {
    var appManager = this.props.appManager;
    var loggedIn = this.props.appManager.isLoggedIn();
    if( !loggedIn && this.state.isShowingHome )
    {
      this.goToPage(0);
      this.setState({isShowingHome:false, isShowingLogin:true});
    }
  },

  didUpdate : function(data)
  {

  },

  _phoneTextCountryCode : "1",
  _phoneText1 : "",
  _phoneText2 : "",
  _phoneText3 : "",
  hasValidPhone : function()
  {
    return this._phoneText1.length == 3 && this._phoneText2.length == 3 && this._phoneText3.length == 4;
  },

  setIsInError: function(isInError, errorMessage)
  {
    if( isInError != this.state.isInError ) this.setState({isInError});
    if( typeof errorMessage !== 'undefined' && errorMessage != this.state.errorMessage )
    {
      this.setState({errorMessage})
    }
    else if( typeof errorMessage === 'undefined' && this.state.errorMessage != null )
    {
      this.setState({errorMessage:null})
    }
  },

  _phoneText1Placeholder : "###",
  _phoneText2Placeholder : "###",
  _phoneText3Placeholder : "####",
  backSpacePressed : function(fieldKey)
  {
    switch (fieldKey) {
      case 'code1':
        break;
      case 'code2':
        if( this._codeText2.length <= 0 )
        {
          this._codeText1 = "";
          this._code1.setText("");
          this._code1.focus();
        }
        break;
      case 'code3':
        if( this._codeText3.length <= 0 )
        {
          this._codeText2 = "";
          this._code2.setText("");
          this._code2.focus();
        }
        break;
      case 'code4':
        if( this._codeText4.length <= 0 )
        {
          this._codeText3 = "";
          this._code3.setText("");
          this._code3.focus();
        }
        break;
      case 'code5':
        if( this._codeText5.length <= 0 )
        {
          this._codeText4 = "";
          this._code4.setText("");
          this._code4.focus();
        }
        break;
      case 'code6':
        if( this._codeText6.length <= 0 )
        {
          this._codeText5 = "";
          this._code5.setText("");
          this._code5.focus();
        }
        break;
      case 'phone1':
        break;
      case 'phone2':
        if( this._phoneText2.length <= 0 )
        {
          this._phoneText1 = "";
          this._phone1.setText("");
          this._phone1.focus();
        }
        break;
      case 'phone3':
        if( this._phoneText3.length <= 0 )
        {
          this._phoneText2 = "";
          this._phone2.setText("");
          this._phone2.focus();
        }
        break;
      default:

    }
  },

  storeFocus: function()
  {
    if( this._focusStore ) this._focusStore.focus();
  },

  render: function()
  {
    var thisThing = this;
    var appManager = this.props.appManager;
    var appActions = this.props.appActions;
    var locManager = appManager.getLocalizationManager();

    var bgImage = this.props.appManager.absoluteResourceForPath("Feed" + '/' + this.props.featureData.bgImage);

    var headerColor = appManager.getColorForKey("HeaderColor");
    var headerIconColor = appManager.getColorForKey("HeaderIconColor");
    var headerTitleColor = appManager.getColorForKey("HeaderTitleColor");
    var profileColor = appManager.getColorForKey("ProfileColor");
    var profileTitleColor = appManager.getColorForKey("ProfileTitleColor");
    var profileMeterColor = appManager.getColorForKey("ProfileMeterColor");
    var profileMeterBackgroundColor = appManager.getColorForKey("ProfileMeterBackgroundColor");
    var profileIconColor = appManager.getColorForKey("ProfileIconColor");
    var profileImageColor = appManager.getColorForKey("ProfileImageColor");
    var generalColor = appManager.getColorForKey("GeneralColor");
    var generalTitleColor = appManager.getColorForKey("GeneralTitleColor");
    var iconColor = appManager.getColorForKey("ButtonPrimaryColor");
    var rippleColor = appManager.getColorForKey("ButtonPrimaryColor",.6);
    var circleIconColor = appManager.getColorForKey("ProfileImageColor");

    var simpleCFD = appManager.getFeatureForName("SimpleCFD");
    var termsPreferencesFeatureData = appManager.getFeatureForName("TermsPreferences");

    var showBack = this.showBack;

    var iconImageName = appManager.absoluteResourceForPath('App/iTunesArtwork.png');
    var stripImage = appManager.absoluteResourceForPath("MyCard/strip.png");
    var headerImage = appManager.absoluteResourceForPath("Feed/header.png");
    var termsAndPreferencesLocalized = locManager.localizedStringForKey("TERMS_AND_PREFERENCES_BUTTON");

    var stripHeight = 120;

    var rewardTitle = "";
    var rewardCost = "";
    var nextReward = {Points:1};
    var amountFontSize = 40;
    if( this.state.rewards.length > 0 )
    {
      for( var i = 0; i < this.state.rewards.length; i++ )
      {
        if( this.state.rewards[i].IsDeleted == "1" ) continue;
        nextReward = this.state.rewards[i];
        break;
      }
      rewardTitle = nextReward.RewardName;
      rewardCost = locManager.localizedPoints(nextReward.Points);
      amountFontSize = 40 - ((this.state.points + "").length > 3 ? ((this.state.points + "").length - 3)*12 : 0);
    }

    var meterDim = 240;
    if( this.props.initialLayout.width > 0 ) meterDim = Math.min(meterDim, this.props.initialLayout.width*.8);
    if( this.props.initialLayout.height > 0 ) meterDim = Math.min(meterDim, this.props.initialLayout.height - 330);
    meterDim = Math.max(meterDim, 110);
    meterDim = Math.min(meterDim, 160);

    var dollarsPerPointInstruction = "";
    if( this.state.dollarsPerPoint != null )
    {
      dollarsPerPointInstruction = locManager.localizedStringForKeyAndParams("DOLLARS_PER_POINT_INSTRUCTION", [locManager.localizedPoints(Math.round(1/this.state.dollarsPerPoint)), locManager.localizedDollars(1)]);
    }

    var phoneSeparators = ["(",") "," - "];

    if( this.state.isShowingCFD )
    {
      return this.props.featureBuilder.featureForData(appManager.getFeatureForName("SimpleCFD"), {width:this.props.initialLayout.width, height:this.props.initialLayout.height}, this.props.appManager)
    }

    return <View style={[styles.container, {backgroundColor:generalColor, height:this.props.initialLayout.height, width:this.props.initialLayout.width}]}>
      <BlurView ref={(c) => { this._ref_blurView = c; }} blurType="light" initialOpacity={0} style={{position:'absolute', left:0, right:0, top:0, bottom:0}} imageName={bgImage} imageKey={appManager.getImageKey("bg")} />
      <MKTextField ref={(a) => { this._focusStore = a }} style={{display:'none'}} />
      <Animated.View style={
      {
        display:this.state.isShowingFront ? 'block' : 'none',
        transform: [{ rotateY: this.state.rotationFront}],
        flexDirection:'column', alignSelf:'stretch', flex:1, marginLeft:this.state.horizontalMargin, marginRight:this.state.horizontalMargin, marginTop:this.state.verticalMargin, marginBottom:this.state.verticalMargin, borderRadius:20, backgroundColor:generalColor,
        overflow:'hidden'
      }}>
      {
        this.state.isShowingError ?
          <View style={{flex:1, flexDirection:'column', alignSelf:'stretch', alignItems:'center', justifyContent:'center'}}>
            <ReUpText appManager={appManager} isTitle={true} style={{textAlign:'center', margin:10}}>
            {this.state.errorTitle}
            </ReUpText>
            <ReUpText appManager={appManager} style={{textAlign:'center', margin:10}}>
            {this.state.errorBody}
            </ReUpText>
          </View>
        : null
      }
      {
        this.state.isShowingHome ?
          <View key="feedPlusView" ref={(a)=>{if( a != null ) thisThing._feedPlusView = a}}
            style={{backgroundColor:profileColor, flexDirection:'column', flex:1, alignSelf:'stretch', height:this.props.initialLayout.height-(2*this.state.verticalMargin)}}>
            <View style={{height:30}}>
            </View>
            <View style={{height:stripHeight, backgroundColor:profileImageColor}}>
              <Image style={{width:'100%', height:stripHeight}} resizeMode={"cover"} source={{uri: stripImage}} />
              <View style={{position:'absolute', top:20, left:20, right:20, bottom:20}}>
                <Image style={{width:'100%', height:stripHeight-40}} resizeMode={"contain"} source={{uri: headerImage}} />
              </View>
            </View>
            <View style={{alignItems:'center', flexDirection:'column', margin:10}}>
              <ArcMeter key="rewardmeter" fgColor={profileMeterColor} dimension={meterDim} thickness={16} bgColor={profileMeterBackgroundColor} percentage={(parseInt(this.state.points) > parseInt(nextReward.Points)) ? 1 : parseFloat((this.state.points)/Math.max(1,nextReward.Points))}>
                <View style={{flexDirection:'column', width:150, justifyContent:'center', alignItems:'center'}}>
                  <View style={{flex:1}} />
                  <PointsTicker key={"pointsticker"} appManager={appManager} points={(parseInt(this.state.points))} style={[{fontSize:amountFontSize, color:circleIconColor, justifyContent:'center'}]}
                    renderText={(points)=>Math.round(points)}/>
                  <View style={{flex:1}}/>
                </View>
              </ArcMeter>
            </View>
            <View style={{flexDirection:'column', alignItems:'center'}}>
              <ReUpText appManager={appManager} isTitle={true} style={{color:profileTitleColor, textAlign:'center', marginBottom:4}}>
              {rewardTitle}
              </ReUpText>
              <ReUpText appManager={appManager} style={{color:profileTitleColor, textAlign:'center'}}>
              {rewardCost}
              </ReUpText>
            </View>
            <View style={{flex:1}} />
            <View style={{flexDirection:'column', alignItems:'center'}}>
              <ReUpText appManager={appManager} style={{color:profileTitleColor, textAlign:'center', margin:10}}>
              {dollarsPerPointInstruction}
              </ReUpText>
            </View>
            <View style={{flex:1}} />
            <View style={{flexDirection:'column', alignItems:'center', marginBottom:20}}>
            <ReUpButton appManager={appManager} isSecondary={true} style={{width:240}} text={termsAndPreferencesLocalized}
                onPress={()=>
                {
                  thisThing.showBack();
                }} />
            </View>
          </View>
        : null
      }
      </Animated.View>
      <Animated.View style={
        {
          display:this.state.isShowingFront ? 'none' : 'block',
          flexDirection:'column',
          transform: [{ rotateY: this.state.rotationBack}],
          alignSelf:'stretch', flex:1, marginLeft:this.state.horizontalMargin, marginRight:this.state.horizontalMargin, marginTop:this.state.verticalMargin, marginBottom:this.state.verticalMargin, borderRadius:20, backgroundColor:headerColor,
          alignItems:'stretch',
          overflow:'hidden'
        }}>
        <View key="feedPlusView" ref={(a)=>{if( a != null ) thisThing._feedPlusView = a}}
          style={{backgroundColor:headerColor, flexDirection:'column', flex:1, alignSelf:'stretch', height:this.props.initialLayout.height-(2*this.state.verticalMargin)}}>
          <View style={{height:60, flexDirection:'row', alignItems:'stretch', justifyContent:'center', backgroundColor:generalColor}}>
            <View style={{width:60, justifyContent:'center', alignItems:'center'}}>
              <ReUpIconButton appManager={appManager} iconName={"angle-left"} onPress={()=>this.showFront()} type={2} />
            </View>
            <View style={{flex:1, justifyContent:'center', alignItems:'center'}}>
            </View>
            <View style={{width:60}}>
            </View>
          </View>
          <View style={{flex:1, flexDirection:'column', alignItems:'stretch'}}>
          {this.props.featureBuilder.featureForData(termsPreferencesFeatureData, {width:this.props.initialLayout.width - 2*this.state.horizontalMargin, height:this.props.initialLayout.height-40-(2*this.state.verticalMargin)}, this.props.appManager)}
          </View>
        </View>
      </Animated.View>
    </View>;
  }
});

var styles = StyleSheet.create({
  container:{
    flex: 1,
    alignItems: 'stretch',
    flexDirection: 'column',
  },
  actionBarSpacer: {
    height:Globals.ACTION_BAR_HEIGHT,
    backgroundColor:'red'
  },
  instructionContainer: {
    flexDirection:'row',
  },
  instructionText: {
    margin:10,
  },
  backgroundView: {
    position: 'absolute',
  },
  feedHeader: {
    height:FEED_HEADER_HEIGHT,
    flexDirection:'row'
  },
  feedHeaderLeftContainer: {
    padding:10,
    width:FEED_HEADER_HEIGHT + 4,
    height:FEED_HEADER_HEIGHT,
    alignItems:'center',
    justifyContent:'center',
  },
  profileImage: {
    height:FEED_HEADER_HEIGHT - 16,
    width:FEED_HEADER_HEIGHT - 16,
    borderRadius:(FEED_HEADER_HEIGHT - 16)/2,
    borderWidth:2,
    borderColor:'black',
    justifyContent:'center',
  },
  profileImageText: {
    textAlign:'center',
    fontSize:(FEED_HEADER_HEIGHT - 20)/2,
    fontWeight:'bold',
    backgroundColor:'transparent'
  },
  feedHeaderCenterContainer: {
    height:FEED_HEADER_HEIGHT,
    paddingVertical:10,
    flex:1,
    justifyContent:'space-between',
  },

  feedHeaderRightContainer: {
    paddingVertical:10,
    width:FEED_HEADER_HEIGHT + 4,
    height:FEED_HEADER_HEIGHT,
    justifyContent:'space-between',
    alignItems:'center',
  },
  feedHeaderInfo: {
    fontWeight:'bold'
  },
})
BasicHome.dataDependencies = ["Users", "Rewards"];

module.exports = BasicHome;
